import type { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import type { IElementAutoLayoutService } from '@src/slide/application/service/element-auto-layout-service/element-auto-layout-service.interface';
import type { INumberTestManager } from '@src/slide/application/service/number-test-manager/number-test-manager.interface';
import type { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import { QUICK_TOOL_AID_POSITION } from '.';
import { IToolbarStateManager } from '../../toolbar-state-manager/core/toolbar-state-manager.interface';
import { ITipsManager } from '../../tips-manager/core/tips-manager.interface';
import { IUserPriviledgeService } from '../../user-priviledge-service/user-priviledge-service.interface';

export interface FontFamilyInfo {
    titleFontEa?: string;
    titleFontLatin?: string;
    contentFontEa?: string;
    contentFontLatin?: string;
}

// 页内应用字体的范围
export enum EFontFamilyApplyPart {
    ALL = 'all', // 标题+正文
    TITLE = 'title', // 标题
    CONTENT = 'content', // 正文
}

// 应用的页
export enum EFontFamilyApplySlide {
    ALL = 'all', // 全部页
    CURRENT = 'current', // 当前页
}

export interface IQuickToolDialogManagerInjectable {
    getFontListFontListModule(): Promise<React.ReactNode|undefined>;
    getQuickToolFontList(): IQuickToolFontList;
}

export interface IQuickToolDialogManager {
    setServiceDelegates(services: IQuickToolDialogManagerDelegates): void;
    showDialog(
        dialogType: string,
        position?: QUICK_TOOL_AID_POSITION,
        onSelect?: () => void,
        onCancel?: () => void,
    ): Promise<void>;
    showUniformFontDialog(
        position?: QUICK_TOOL_AID_POSITION,
        onSelect?: () => void,
        onCancel?: () => void,
        fontFamilyInfo?: FontFamilyInfo,
    ): Promise<void>;
    hideDialog(): void;
    handleClickOk(apprec: string, name: string): void;
    updateDialog(visible: boolean, position: QUICK_TOOL_AID_POSITION): void;
    getRecommendFontList(batchIndex?: number, oneBatchCount?: number): string[];
    applyFont(
        fontName: string,
        applyPart?: EFontFamilyApplyPart,
        applySlides?: EFontFamilyApplySlide,
    ): Promise<void>
}

export interface IQuickToolDialogManagerDelegates {
    selectionService: ISelectionService;
    elementAutoLayoutService: IElementAutoLayoutService;
    numberTestManager?: INumberTestManager;
    masterLayoutEditService?: IMasterLayoutEditService;
    toolbarStateManager: IToolbarStateManager;
    tipsManager: ITipsManager;
    userPrivilegeService: IUserPriviledgeService;
}

export interface QuickToolFontListProps {
    onFontChange: (fontFamily: string) => void;
    selectedFontFamily: string;
    FontListModule: any;
}

export type IQuickToolFontList = React.FC<QuickToolFontListProps>;
